import { List } from 'immutable'
import * as React from 'react'
import { Entity } from 'ts-lenses'
import { async, fromJSX, Updater, Widget } from 'widgets-for-react'
import { cookieBarStateUpdaters } from '../cookiebar/cookiebar.state'
import { cookiebarWidget } from '../cookiebar/cookiebar.widget'
import { ModuleState, StateRequirements } from '../publicSite/publicSite.module.state'
import { RootLayout } from '../root/root.layout'
import { renderPage } from './cmsPage.layout'
import { CMSBlocksState, CMSLoaderState } from './cmsPage.state'
import { DP } from './drupal/blockDefinitions'
import { publicSiteFooterWidget } from './footer/cmsFooter.widget'
import { publicSiteMenuHeaderWidget } from './header/siteHeader/cmsSiteHeader.widget'
import { ModernBlock, ModernBlockProps } from './modernBlocks/modernBlocks.state'
import { getPopups } from './popup/popup.api'
import { popupWidget } from './popup/popup.widget'

export type State = ModuleState & StateRequirements

export const metaTitle = ' | ReumaNederland'

export const cmsWidget = (localState: State): Widget<Updater<State>> => {
  const { loader } = localState.rootModernBlocksState
  if (loader.kind == 'loaded')
    document.title = loader.value.pageData.metadata.title || loader.value.pageData.header.pageTitle + metaTitle

  return fromJSX((setState) => {
    return (
      <>
        {cookiebarWidget(localState.cookiebarState).map(cookieBarStateUpdaters.updateCookiebarState).run(setState)}
        {publicSiteMenuHeaderWidget(localState).run(setState)}
        {fetchModernBlocks(localState).run(setState)}
        {renderPage(localState, setState).run(setState)}
        {publicSiteFooterWidget(localState).run(setState)}
        {popupWidget(localState.popupState).run(setState)}
      </>
    )
  })
}

export const renderReadSpeaker = (s: State):boolean => {
  if(s.rootModernBlocksState.loader.kind == 'failed') return true
  if(s.rootModernBlocksState.loader.kind != 'loaded') return false

  // TODO: include exceptions here (maybe?)

  return true
}

function fetchModernBlocks(localState: State): Widget<Updater<State>> {
  return async<CMSLoaderState>(localState.rootModernBlocksState.loader, undefined, {
    key: localState.rootModernBlocksState.loader.kind,
    loading: (_) => fromJSX((_) => <></>),
    connectionError: fromJSX((_) => <RootLayout.Error kind='notFound' showReadspeaker={renderReadSpeaker(localState)} />),
    unauthorizedError: fromJSX((_) => <RootLayout.Error kind='unauthorized' showReadspeaker={renderReadSpeaker(localState)} />)
  }).map((loader) => (currentState) => {
            // debugger
            let currentCMSState = currentState.rootModernBlocksState
            let newRootModernBlocksState = Entity(currentCMSState)
              .set('loader', (prevLoader) => loader(prevLoader))
              .commit() as CMSBlocksState
            if (newRootModernBlocksState.loader.kind == "loaded") {
                // translate blocks from cms blocks to modern blocks
                let modernBlocks = parseCMSBlockToModerBlock(newRootModernBlocksState.loader.value.blocks, newRootModernBlocksState.modernBlocks.environment);
                newRootModernBlocksState = Entity(newRootModernBlocksState)
                    .set("modernBlocks", prevModernBlocksState => ({ ...prevModernBlocksState, blocks: modernBlocks }))
                    .commit() as CMSBlocksState;
            }

            const popupState = getPopups(currentState.popupState, newRootModernBlocksState)

            return { ...currentState, rootModernBlocksState: newRootModernBlocksState, popupState: popupState };
        })
}
export function parseCMSBlockToModerBlock(blocks: DP.DPBlock[], environment: "drupal" | "sharepoint") {
  if(blocks == undefined) return List<ModernBlockProps>()
  return List<ModernBlockProps>(blocks
    .map((cmsBlock: any, i: number) => {
      // console.log(' found super blocks for CMS', cmsBlock)
      let modernBlockDefinitions = (window as any)["modernBlocks"]

      for (const blockDefinition in modernBlockDefinitions) {
        let modernBlockRecord: ModernBlock<any, any, any> = modernBlockDefinitions[blockDefinition]
        try {
          if (modernBlockRecord.adapters[environment] &&
            modernBlockRecord.adapters[environment]!(cmsBlock, i)) {
            return {
              kind: modernBlockRecord.kind,
              props: modernBlockRecord.adapters[environment]!(cmsBlock, i)
            } as ModernBlockProps
          }
        } catch (error) {
          // alert('Error occurred while adapting CMS properties to Modern Block. ' + JSON.stringify({ error, cmsBlock }));
          console.error('Error occurred while adapting CMS properties to Modern Block', error, cmsBlock)
        }
      }
      // alert('Error. No adapter found for this block. ' + cmsBlock.blockName)
      /**
       * Because the API response of Drupal or maybe other contentmanagement systems may
       * have another blockname property coming from the API...
      */
      console.error('Error. No adapter found for this block', cmsBlock.target.type[0].target_id)

      return undefined
    }).filter((b: any) => b != undefined))
}

